const util = {};
util.storage = {};
util.pagina = {};
util.alert = {};

// Utilidades para LocalStorage
util.storage.get = (item) => {
    if(localStorage.getItem(item)!=null){
        return JSON.parse(localStorage.getItem(item));
    }else{
        return null;
    }
};

util.storage.set = (item, data) => {
    localStorage.setItem(item, JSON.stringify(data));
};

util.storage.delete = (item) => {
    localStorage.removeItem(item);
};

util.limpiarStorage = () => {
    localStorage.clear();
};

// Utilidades para alertas
util.alert.success = (entorno, titulo, mensaje) => {
    entorno.$swal({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5500,
        timerProgressBar: true,
        icon: 'success',
        title: titulo,
        text: mensaje
    });
};

util.alert.custom = (entorno, type, titulo, mensaje) => {
    entorno.$swal({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5500,
        timerProgressBar: true,
        icon: type,
        title: titulo,
        text: mensaje
    });
};

// Otras Utilidades
util.cerrarSesion = (entorno) => {
    localStorage.clear();
    entorno.$router.push("/login");
};

util.pagina.go = (entorno, pagina) => {
    entorno.$router.push(pagina);
};

util.pagina.anterior = (entorno) => {
    entorno.$router.go(-1);
};

export default util;


// WEBPACK FOOTER //
// ./src/tools/util.js